export type ApiErrorCode =
  | 'GRAPHIC_NAME_ALREADY_EXISTS'
  | 'FREQUENCY_IMMUTABLE'
  | 'INVALID_FREQUENCY_CODE'
  | 'UNIT_NAME_ALREADY_EXISTS'
  | 'AUTOMATIC_EXTERNAL_ID_ALREADY_EXISTS'
  | 'CAMPAIGN_TIMESTAMP_ALREADY_EXISTS'
  | 'ENTITY_REFERENCED';

type LocalizedMessages = { [K in ApiErrorCode]?: string } & Record<string, string | undefined>;

export const ApiErrorMessages: Record<string, LocalizedMessages> = {
  en: {
    GRAPHIC_NAME_ALREADY_EXISTS: 'A graphic with this name already exists',
    FREQUENCY_IMMUTABLE: 'The sampling frequency cannot be changed once it has been set',
    INVALID_FREQUENCY_CODE: 'Invalid sampling frequency',
    UNIT_NAME_ALREADY_EXISTS: 'A unit with this name already exists for this type',
    AUTOMATIC_EXTERNAL_ID_ALREADY_EXISTS: 'This external identifier is already used by another measure on the same asset',
    CAMPAIGN_TIMESTAMP_ALREADY_EXISTS: 'A campaign already exists for this asset at this date and time',
    ENTITY_REFERENCED: 'Cannot delete: this item is still referenced by other resources',
  },
  fr: {
    GRAPHIC_NAME_ALREADY_EXISTS: 'Un graphique avec ce nom existe déjà',
    FREQUENCY_IMMUTABLE: "La fréquence d'échantillonnage ne peut pas être modifiée une fois définie",
    INVALID_FREQUENCY_CODE: "Fréquence d'échantillonnage invalide",
    UNIT_NAME_ALREADY_EXISTS: 'Une unité de ce type existe déjà avec ce nom',
    AUTOMATIC_EXTERNAL_ID_ALREADY_EXISTS: 'Cet identifiant externe est déjà utilisé par une autre mesure du même ouvrage',
    CAMPAIGN_TIMESTAMP_ALREADY_EXISTS: 'Une campagne existe déjà pour cet ouvrage à cette date et heure',
    ENTITY_REFERENCED: 'Suppression impossible : cet élément est encore référencé par d’autres ressources',
  },
  de: {
    GRAPHIC_NAME_ALREADY_EXISTS: 'Eine Grafik mit diesem Namen existiert bereits',
    FREQUENCY_IMMUTABLE: 'Die Abtastfrequenz kann nach der Festlegung nicht mehr geändert werden',
    INVALID_FREQUENCY_CODE: 'Ungültige Abtastfrequenz',
    UNIT_NAME_ALREADY_EXISTS: 'Eine Einheit dieses Typs mit diesem Namen existiert bereits',
    AUTOMATIC_EXTERNAL_ID_ALREADY_EXISTS: 'Diese externe Kennung wird bereits von einer anderen Messung dieses Bauwerks verwendet',
    CAMPAIGN_TIMESTAMP_ALREADY_EXISTS: 'Für dieses Bauwerk existiert bereits eine Kampagne zu diesem Datum und dieser Uhrzeit',
    ENTITY_REFERENCED: 'Löschen nicht möglich: Dieses Element wird noch von anderen Ressourcen referenziert',
  },
  it: {
    GRAPHIC_NAME_ALREADY_EXISTS: 'Esiste già un grafico con questo nome',
    FREQUENCY_IMMUTABLE: 'La frequenza di campionamento non può essere modificata una volta impostata',
    INVALID_FREQUENCY_CODE: 'Frequenza di campionamento non valida',
    UNIT_NAME_ALREADY_EXISTS: "Esiste già un'unità di questo tipo con questo nome",
    AUTOMATIC_EXTERNAL_ID_ALREADY_EXISTS: "Questo identificatore esterno è già utilizzato da un'altra misura della stessa opera",
    CAMPAIGN_TIMESTAMP_ALREADY_EXISTS: "Esiste già una campagna per quest'opera a questa data e ora",
    ENTITY_REFERENCED: 'Impossibile eliminare: questo elemento è ancora riferito da altre risorse',
  },
};
